// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const createWorkspacePayloadSchema = z.object({
  name: z.string(),
  organization: urlSchema,
});
